/* eslint-disable */
import CommentEntity from "../Entity/Comment";
import moment from "moment";
import 'moment/locale/ru';

let CommentFactory = function(data) {
	var comment = new CommentEntity(),
		element;

	element = data['id'];
	if(typeof element != "undefined") {
		comment.set('id', element);
	}
	
	element = data['user'];
	if(typeof element != "undefined") {
		comment.set('user', element);
	}
	
	element = data['created'];
	if(typeof element != "undefined") {
		comment.set('created', moment(element, "YYYY-MM-DD hh:mm:ss"));
	}
	
	element = data['text'];
	if(typeof element != "undefined") {
		comment.set('text', element);
	}
	
	element = data['rate'];
	if(element != "undefined") {
		comment.set('rate', parseFloat(element));
	}
	
	element = data['mealRate'];
	if(element != "undefined") {
		comment.set('mealRate', parseFloat(element));
	}
	
	element = data['serviceRate'];
	if(element != "undefined") {
		comment.set('serviceRate', parseFloat(element));
	}
	
	element = data['locationRate'];
	if(element != "undefined") {
		comment.set('locationRate', parseFloat(element));
	}
	
	return comment;
};

export default CommentFactory;